[
  { "date": "2023-12-24", "holidayName": "Julafton" },
  { "date": "2023-12-25", "holidayName": "Juldagen" },
  { "date": "2023-12-26", "holidayName": "Annandag jul" },
  { "date": "2023-12-31", "holidayName": "Nyårsafton" },
  { "date": "2024-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2024-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2024-03-29", "holidayName": "Långfredagen" },
  { "date": "2024-03-31", "holidayName": "Påskdagen" },
  { "date": "2024-04-01", "holidayName": "Annandag påsk" },
  { "date": "2024-05-01", "holidayName": "Första maj" },
  { "date": "2024-05-09", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2024-05-19", "holidayName": "Pingstdagen" },
  { "date": "2024-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2024-06-21", "holidayName": "Midsommarafton" },
  { "date": "2024-06-22", "holidayName": "Midsommardagen" },
  { "date": "2024-11-02", "holidayName": "Alla helgons dag" },
  { "date": "2024-12-24", "holidayName": "Julafton" },
  { "date": "2024-12-25", "holidayName": "Juldagen" },
  { "date": "2024-12-26", "holidayName": "Annandag jul" },
  { "date": "2024-12-31", "holidayName": "Nyårsafton" },
  { "date": "2025-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2025-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2025-04-18", "holidayName": "Långfredagen" },
  { "date": "2025-04-20", "holidayName": "Påskdagen" },
  { "date": "2025-04-21", "holidayName": "Annandag påsk" },
  { "date": "2025-05-01", "holidayName": "Första maj" },
  { "date": "2025-05-29", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2025-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2025-06-08", "holidayName": "Pingstdagen" },
  { "date": "2025-06-20", "holidayName": "Midsommarafton" },
  { "date": "2025-06-21", "holidayName": "Midsommardagen" },
  { "date": "2025-11-01", "holidayName": "Alla helgons dag" },
  { "date": "2025-12-24", "holidayName": "Julafton" },
  { "date": "2025-12-25", "holidayName": "Juldagen" },
  { "date": "2025-12-26", "holidayName": "Annandag jul" },
  { "date": "2025-12-31", "holidayName": "Nyårsafton" },
  { "date": "2026-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2026-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2026-04-03", "holidayName": "Långfredagen" },
  { "date": "2026-04-05", "holidayName": "Påskdagen" },
  { "date": "2026-04-06", "holidayName": "Annandag påsk" },
  { "date": "2026-05-01", "holidayName": "Första maj" },
  { "date": "2026-05-14", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2026-05-24", "holidayName": "Pingstdagen" },
  { "date": "2026-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2026-06-19", "holidayName": "Midsommarafton" },
  { "date": "2026-06-20", "holidayName": "Midsommardagen" },
  { "date": "2026-10-31", "holidayName": "Alla helgons dag" },
  { "date": "2026-12-24", "holidayName": "Julafton" },
  { "date": "2026-12-25", "holidayName": "Juldagen" },
  { "date": "2026-12-26", "holidayName": "Annandag jul" },
  { "date": "2026-12-31", "holidayName": "Nyårsafton" },
  { "date": "2027-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2027-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2027-03-26", "holidayName": "Långfredagen" },
  { "date": "2027-03-28", "holidayName": "Påskdagen" },
  { "date": "2027-03-29", "holidayName": "Annandag påsk" },
  { "date": "2027-05-01", "holidayName": "Första maj" },
  { "date": "2027-05-06", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2027-05-16", "holidayName": "Pingstdagen" },
  { "date": "2027-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2027-06-25", "holidayName": "Midsommarafton" },
  { "date": "2027-06-26", "holidayName": "Midsommardagen" },
  { "date": "2027-11-06", "holidayName": "Alla helgons dag" },
  { "date": "2027-12-24", "holidayName": "Julafton" },
  { "date": "2027-12-25", "holidayName": "Juldagen" },
  { "date": "2027-12-26", "holidayName": "Annandag jul" },
  { "date": "2027-12-31", "holidayName": "Nyårsafton" },
  { "date": "2028-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2028-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2028-04-14", "holidayName": "Långfredagen" },
  { "date": "2028-04-16", "holidayName": "Påskdagen" },
  { "date": "2028-04-17", "holidayName": "Annandag påsk" },
  { "date": "2028-05-01", "holidayName": "Första maj" },
  { "date": "2028-05-25", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2028-06-04", "holidayName": "Pingstdagen" },
  { "date": "2028-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2028-06-23", "holidayName": "Midsommarafton" },
  { "date": "2028-06-24", "holidayName": "Midsommardagen" },
  { "date": "2028-11-04", "holidayName": "Alla helgons dag" },
  { "date": "2028-12-24", "holidayName": "Julafton" },
  { "date": "2028-12-25", "holidayName": "Juldagen" },
  { "date": "2028-12-26", "holidayName": "Annandag jul" },
  { "date": "2028-12-31", "holidayName": "Nyårsafton" },
  { "date": "2029-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2029-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2029-03-30", "holidayName": "Långfredagen" },
  { "date": "2029-04-01", "holidayName": "Påskdagen" },
  { "date": "2029-04-02", "holidayName": "Annandag påsk" },
  { "date": "2029-05-01", "holidayName": "Första maj" },
  { "date": "2029-05-10", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2029-05-20", "holidayName": "Pingstdagen" },
  { "date": "2029-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2029-06-22", "holidayName": "Midsommarafton" },
  { "date": "2029-06-23", "holidayName": "Midsommardagen" },
  { "date": "2029-11-03", "holidayName": "Alla helgons dag" },
  { "date": "2029-12-24", "holidayName": "Julafton" },
  { "date": "2029-12-25", "holidayName": "Juldagen" },
  { "date": "2029-12-26", "holidayName": "Annandag jul" },
  { "date": "2029-12-31", "holidayName": "Nyårsafton" },
  { "date": "2030-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2030-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2030-04-19", "holidayName": "Långfredagen" },
  { "date": "2030-04-21", "holidayName": "Påskdagen" },
  { "date": "2030-04-22", "holidayName": "Annandag påsk" },
  { "date": "2030-05-01", "holidayName": "Första maj" },
  { "date": "2030-05-30", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2030-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2030-06-09", "holidayName": "Pingstdagen" },
  { "date": "2030-06-21", "holidayName": "Midsommarafton" },
  { "date": "2030-06-22", "holidayName": "Midsommardagen" },
  { "date": "2030-11-02", "holidayName": "Alla helgons dag" },
  { "date": "2030-12-24", "holidayName": "Julafton" },
  { "date": "2030-12-25", "holidayName": "Juldagen" },
  { "date": "2030-12-26", "holidayName": "Annandag jul" },
  { "date": "2030-12-31", "holidayName": "Nyårsafton" },
  { "date": "2031-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2031-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2031-04-11", "holidayName": "Långfredagen" },
  { "date": "2031-04-13", "holidayName": "Påskdagen" },
  { "date": "2031-04-14", "holidayName": "Annandag påsk" },
  { "date": "2031-05-01", "holidayName": "Första maj" },
  { "date": "2031-05-22", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2031-06-01", "holidayName": "Pingstdagen" },
  { "date": "2031-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2031-06-20", "holidayName": "Midsommarafton" },
  { "date": "2031-06-21", "holidayName": "Midsommardagen" },
  { "date": "2031-11-01", "holidayName": "Alla helgons dag" },
  { "date": "2031-12-24", "holidayName": "Julafton" },
  { "date": "2031-12-25", "holidayName": "Juldagen" },
  { "date": "2031-12-26", "holidayName": "Annandag jul" },
  { "date": "2031-12-31", "holidayName": "Nyårsafton" },
  { "date": "2032-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2032-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2032-03-26", "holidayName": "Långfredagen" },
  { "date": "2032-03-28", "holidayName": "Påskdagen" },
  { "date": "2032-03-29", "holidayName": "Annandag påsk" },
  { "date": "2032-05-01", "holidayName": "Första maj" },
  { "date": "2032-05-06", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2032-05-16", "holidayName": "Pingstdagen" },
  { "date": "2032-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2032-06-25", "holidayName": "Midsommarafton" },
  { "date": "2032-06-26", "holidayName": "Midsommardagen" },
  { "date": "2032-11-06", "holidayName": "Alla helgons dag" },
  { "date": "2032-12-24", "holidayName": "Julafton" },
  { "date": "2032-12-25", "holidayName": "Juldagen" },
  { "date": "2032-12-26", "holidayName": "Annandag jul" },
  { "date": "2032-12-31", "holidayName": "Nyårsafton" },
  { "date": "2033-01-01", "holidayName": "Nyårsdagen" },
  { "date": "2033-01-06", "holidayName": "Trettondedag jul" },
  { "date": "2033-04-15", "holidayName": "Långfredagen" },
  { "date": "2033-04-17", "holidayName": "Påskdagen" },
  { "date": "2033-04-18", "holidayName": "Annandag påsk" },
  { "date": "2033-05-01", "holidayName": "Första maj" },
  { "date": "2033-05-26", "holidayName": "Kristi himmelsfärdsdag" },
  { "date": "2033-06-05", "holidayName": "Pingstdagen" },
  { "date": "2033-06-06", "holidayName": "Sveriges nationaldag" },
  { "date": "2033-06-24", "holidayName": "Midsommarafton" },
  { "date": "2033-06-25", "holidayName": "Midsommardagen" },
  { "date": "2033-11-05", "holidayName": "Alla helgons dag" }
]
